import { memo, useEffect } from 'react';

import { ChatMessage } from './message';
import { ChatMessage as ChatMessageType } from '@/types/socket';
import { useChat } from '@/contexts/chat-context';

const MemoizedChatMessage = memo(ChatMessage);

export const ChatBody = () => {
  const { messages, chatContainerRef, scrollToBottom } = useChat();

  useEffect(() => {
    scrollToBottom('instant');
  }, [scrollToBottom]);

  return (
    <div
      ref={chatContainerRef}
      data-testid="chat-body"
      className="flex-1 overflow-y-auto [&::-webkit-scrollbar]:w-2 [&::-webkit-scrollbar-track]:bg-black/5 [&::-webkit-scrollbar-thumb]:bg-black/20"
    >
      {messages.map((msg: ChatMessageType, index: number) => (
        <MemoizedChatMessage
          key={index}
          role={msg.role}
          content={msg.content}
          isLastMessage={index === messages.length - 1}
        />
      ))}
    </div>
  );
};
